import { default as ReactCountdown } from 'react-countdown'

export type CountdownProps = {
  readonly date: Date | number | string
  readonly onComplete?: () => void
}
export function Countdown(props: CountdownProps) {
  return <ReactCountdown {...props} />
}
